"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMutationObserver = void 0;
const react_1 = require("react");
const useMutationObserver = ({ element, callback, options, shouldObserve = true, }) => {
    const observer = (0, react_1.useMemo)(() => new MutationObserver(callback), [callback]);
    (0, react_1.useEffect)(() => {
        if (shouldObserve && element) {
            observer.observe(element, options);
        }
        return () => observer.disconnect();
    }, [shouldObserve, element, observer, options]);
};
exports.useMutationObserver = useMutationObserver;
//# sourceMappingURL=useMutationObserver.js.map